import {Component} from '@angular/core';
import {NavController ,AlertController, ToastController,Events, ModalController } from 'ionic-angular';
import {CartPage} from "../cart/cart";
import {ItemsPage} from "../items/items";
import {OrderViewPage} from "../order-view/order-view";
import {LoginPage} from '../login/login';
import {SearchPage} from '../search/search';
import {Api} from "../../providers/api";
import {ApiOffline} from "../../providers/api-offline";
import { Headers , RequestOptions } from '@angular/http';
import {CartManager} from "../../providers/cart-manager";
import {ArrayUtils} from "../../utils/array-utils";
import * as moment from 'moment';
import * as timeZone from 'moment-timezone';
import {Constants,ApplicationVariables, isIntelliStock} from '../../providers/config';
import { MsgManager } from '../../providers/msg-manager';
import {CART, STOCKCART, WORKORDER} from '../../providers/data';
import { PickPackParamsPage } from '../pickpackparams/pickpackparams';
import { PickpacklistPage } from '../pickpacklist/pickpacklist';
import {ShipmentcartManagerProvider} from "../../providers/shipmentcart-manager";
import {Storage} from "@ionic/storage";
import {GVLogger} from "../../services/gv-logger";
import {ShipmentslistPage} from "../shipmentslist/shipmentslist";
import { loginUserInfo, orderListStickyVar, loggedInUser } from '../../providers/data';
import {MyOrderPage} from "../my-order/my-order";
import {StockcartPage} from "../stockcart/stockcart";
import {WorkOrderViewPage} from "../work-order-view/work-order-view";
import {ReceiveReturnPage} from "../receive-return/receive-return";
// import {workers} from "@ionic/app-scripts/dist/worker-client";




@Component({
  selector: 'page-work-orders',
  templateUrl: 'work-orders.html'
})
export class WorkOrdersPage {
  // sample data
  public orders: any =  [];
  public allDataLoaded = false;
  public constants = Constants;
  cart:any;
  isOfflineMode = false;

  adpCustomerInfo : any = {};

  ad:any = {  };

  restrictedToViewOrder = loginUserInfo.restrictedToViewOrder;

  offlineOrdersAvailable = false;
  showAds = 0;
  isIntelliStockfunc = isIntelliStock;
  stockCart: any;
  enteredOrderNumber = ""
  selectedWorkOrdersType = loggedInUser.selectedWorkOrdersType
  selectedWorkOrdersStatus = loggedInUser.selectedWorkOrdersStatus
  selectedSortingType = orderListStickyVar.selectedSortingType
  orderTypesList = [{id:-1, name: "All"},{id:this.getLoggedInUserId(), name: "Assigned To Me"}]
  orderStatusesList = [{id:-1, name: "All"},{id:1, name: "No Action"},{id:2, name: "InProgress"},{id:3, name: "Finished"}]

  SortingType = [{name : "Oldest on Top", alias : "Ascending"}, {name : "Newest on Top", alias : "Descending"}]

  loggedInUserWarehouse = loginUserInfo.assignedWarehouseName
  loggedInUserWarehouseId = loginUserInfo.assignedWarehouseId
  loggedInUserWarehouseType = loginUserInfo.assignedWarehouseType
  warehouseType = "Warehouse";


  constructor(public nav: NavController,
   public api:Api,
   public cartManager:CartManager,
   public arrayUtils:ArrayUtils,
   public alertCtrl:AlertController,
   private msgManager:MsgManager,
   private toastCtrl:ToastController,
   private apiOffline:ApiOffline,
   private events:Events,
   private modalCtrl:ModalController,
   private shipmentCartManager:ShipmentcartManagerProvider,
   public storage:Storage,
   private gVLogger: GVLogger) {
    this.getWarehouse();

    this.gVLogger.log("constructor called of my order : ");
    this.adpCustomerInfo = this.cartManager.getAdpCustomerInfo();
    // set sample data
    //this.orders = orderService.getAll();

    this.isOfflineMode = ApplicationVariables.isOffline;

    // IntelliRep Browser Check
      if(!Constants.isWebstore && Constants.IntelliStockRunningIn === "NA" && Constants.IntelliRepRunningIn == "App"){
        this.checkOfflineOrders();
      }


      // this.events.subscribe("SyncCompleted",()=>{
      //   // IntelliRep Browser Check
      //   if(!Constants.isWebstore && Constants.IntelliStockRunningIn === "NA" && Constants.IntelliRepRunningIn == "App"){
      //   this.checkOfflineOrders();
      // }
      //   this.getOrdersResolver(0);
      // });

      this.getShowAds();



    this.getOrdersResolver(0);

    this.cart = CART;
    this.stockCart = STOCKCART;

  }


  getLoggedInUserId(){
    return loginUserInfo.id
  }
  checkifB2CSaleChannel(order){
    if(order.salesChannel === "B2B Store" || order.salesChannel === "B2B Sales Rep" || order.salesChannel === "B2B Warehouse"){
      return false;
    }else {
      return true;
    }
  }



  getOrdersResolver(itemCount){
    this.orders = [];
    this.gVLogger.log("get order resolver method : ");
    // IntelliRep Browser Check
    if(ApplicationVariables.isOffline && Constants.IntelliStockRunningIn === "NA" && Constants.IntelliRepRunningIn == "App"){


      this.getOrdersOffline();
    }else{
      this.getOrdersLazy(itemCount, this.enteredOrderNumber, this.selectedWorkOrdersType, this.selectedSortingType);
      if(itemCount == 0){
        // IntelliRep Browser Check
         if(!Constants.isWebstore && Constants.IntelliStockRunningIn === "NA" && Constants.IntelliRepRunningIn == "App"){
          this.getOrdersOffline();
        }
       // this.getOrdersOffline();
      }
    }
  }

  async viewWorkOrder(order){

    order = await this.getWorkOrderById(order.id);
    loggedInUser.selectedWorkOrdersType = this.selectedWorkOrdersType
    loggedInUser.selectedWorkOrdersStatus = this.selectedWorkOrdersStatus
      this.nav.push(WorkOrderViewPage,{"workOrder": order, "from":"View"});
  }

  getWorkOrderById(workOrderId): Promise<any>{
    return new Promise((resolve,reject) => {
      this.api.get("workOrder/getById?id=" + workOrderId).map(res => res.json()).subscribe(OrderData => {
          this.gVLogger.log("data from /products/getProductsForPickShip : " + OrderData);
          if(OrderData.status === "200") {
            resolve(OrderData.data);
          }
          else {
            this.api.toastMSG("Some thing went wrong while getting orders.");

            reject( null);
          }
        },
        error => {
          this.api.toastMSG("Failed to fetch order data.");
          reject(error);  // ❌ Reject the promise on API failure
        }
      );
    })

  }

  onChangeSelectedOrdersType(){
    loggedInUser.selectedWorkOrdersType = this.selectedWorkOrdersType
    var ordersListCount = 0;

    let searchString = "";

    if(this.enteredOrderNumber.trim() !== ""){
      searchString = this.enteredOrderNumber;
    }


    // var body = "?userId="+this.cartManager.getSalesManId()+"&startPoint="+ ordersListCount+"&searchString="+ searchString +"&orderStatus="+ this.selectedOrdersType+"&sortingType="+this.selectedSortingType;
    // if(Constants.isWebstore){
    //   body = "?customerId="+this.cartManager.getCustomerID()+"&startPoint="+ ordersListCount;
    // }

    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({
      headers: headers
    });

    var url = "workOrder/getWorkOrders";
    if(Constants.isWebstore){
      url = "order/loadByCustomer";
    }

    let body = {
      "offset" : ordersListCount,
      "parentInventoryLocationId": loginUserInfo.assignedWarehouseId,
      "searchQuery": searchString,
      "statusCode": this.selectedWorkOrdersStatus,
      "supplierUuid": "",
      "assignedTo" : this.selectedWorkOrdersType
    }

    this.api.post(url,body,null)
      .map(res=> res.json())
      .subscribe(data=>{
        if(data.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.nav.setRoot(LoginPage);
        }else if(data.status == 200){
          // var temp = this.orders;
          var temp = [];


          for(let order of data.data.workOrdersList){
            this.gVLogger.log("Recived : "+order.updatedAt);
            temp.push(order);
          }

          this.orders = this.arrayUnique(temp);
          if(data.data.workOrdersList == []){
            this.allDataLoaded = true;
          }
          // resolve(true);
        }else {
          this.orders = [];
          this.allDataLoaded = true;
        }
      });
  }

  // onChangeSelectedSortingType(){
  //   this.gVLogger.log("Typppppppppp " + this.selectedSortingType)
  //   orderListStickyVar.selectedSortingType = this.selectedSortingType
  //   var ordersListCount = 0;
  //
  //   let searchString = "-1";
  //
  //   if(this.enteredOrderNumber.trim() !== ""){
  //     searchString = this.enteredOrderNumber;
  //   }
  //
  //
  //   // var body = "?userId="+this.cartManager.getSalesManId()+"&startPoint="+ ordersListCount+"&searchString="+ searchString +"&orderStatus="+ this.selectedOrdersType+"&sortingType="+this.selectedSortingType;
  //   // if(Constants.isWebstore){
  //   //   body = "?customerId="+this.cartManager.getCustomerID()+"&startPoint="+ ordersListCount;
  //   // }
  //
  //   let headers = new Headers({
  //     'Content-Type': 'application/json'
  //   });
  //   let options = new RequestOptions({
  //     headers: headers
  //   });
  //
  //   var url = "workOrder/getWorkOrders";
  //   if(Constants.isWebstore){
  //     url = "order/loadByCustomer";
  //   }
  //
  //   let body = {
  //     "offset" : ordersListCount,
  //     "parentInventoryLocationId": loginUserInfo.assignedWarehouseId,
  //     "searchQuery": searchString,
  //     "statusCode": -1,
  //     "supplierUuid": "",
  //     "assignedTo" : this.selectedWorkOrdersType
  //   }
  //
  //   this.api.post(url,body,null)
  //     .map(res=> res.json())
  //     .subscribe(data=>{
  //       if(data.status == "401"){ // check for session out
  //         this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
  //         this.nav.setRoot(LoginPage);
  //       }else if(data.status == 200){
  //         // var temp = this.orders;
  //         var temp = [];
  //
  //
  //         for(let order of data.data.workOrdersList){
  //           this.gVLogger.log("Recived : "+order.updatedAt);
  //           temp.push(order);
  //         }
  //
  //         this.orders = this.arrayUnique(temp);
  //         if(data.data.workOrdersList == []){
  //           this.allDataLoaded = true;
  //         }
  //         // resolve(true);
  //       }
  //     });
  // }



  findOrderByOrderId(){
    var ordersListCount = 0;
    orderListStickyVar.enteredOrderNumber = this.enteredOrderNumber


    let searchString = "";

    if(this.enteredOrderNumber.trim() !== ""){
      searchString = this.enteredOrderNumber;
    }


    let headers = new Headers({
      'Content-Type': 'application/json'
    });
    let options = new RequestOptions({
      headers: headers
    });

    var url = "workOrder/getWorkOrders";
    if(Constants.isWebstore){
      url = "order/loadByCustomer";
    }

    let body = {
      "offset" : ordersListCount,
      "parentInventoryLocationId": loginUserInfo.assignedWarehouseId,
      "searchQuery": searchString,
      "statusCode": this.selectedWorkOrdersStatus,
      "supplierUuid": "",
      "assignedTo" : this.selectedWorkOrdersType
    }

    this.api.post(url,body,null)
      .map(res=> res.json())
      .subscribe(data=>{
        if(data.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
          this.nav.setRoot(LoginPage);
        }else if(data.status == 200){
          // var temp = this.orders;
          var temp = [];


          for(let order of data.data.workOrdersList){
            this.gVLogger.log("Recived : "+order.updatedAt);
            temp.push(order);
          }

          this.orders = this.arrayUnique(temp);
          if(data.data.workOrdersList == []){
            this.allDataLoaded = true;
          }
          // resolve(true);
        }
      });
  }

  getOrdersOffline(){
    //this.orders = [];
    this.apiOffline.getAllOrders().then((res)=>{
      for(var i=0; i<res.rows.length; i++)
                {
                    var json = JSON.parse(res.rows.item(i).json);
                    this.orders.unshift(json);
                }
    },err=>{
      // alert(JSON.stringify(err));
    });
  }


  async start(order){
    order = await this.getWorkOrderById(order.id)
    loggedInUser.selectedWorkOrdersType = this.selectedWorkOrdersType
    loggedInUser.selectedWorkOrdersStatus = this.selectedWorkOrdersStatus

    order.createdAt = "";
    order.assignedAt = "";
    order.startedAt = "";

    if(order.type === "Make to Stock"){
      // let body = {
      //   customerOrderNumber : order.referenceNo
      // }
      // this.api.post("order/checkByCustomerOrderNumberAndSystemCustomer", body).map(res => res.json()).subscribe(data => {
        // if(data.status == "401"){ // check for session out
        //   this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        //
        //   this.nav.setRoot(LoginPage);
        // }
        // if(data.status === "403"){
          this.api.toastMSG("Please click 'Select Items' to begin production")
          this.viewWorkOrder(order);
        // }else {
        //   this.actionInCaseOfTypeReceiveStock(order)
        //
        // }
      // })

    }
    else if(order.type === "Transfer Order"){
      this.updateWorkOrder(order);

      orderListStickyVar.enteredOrderNumber = order.jobId
      this.nav.setRoot(MyOrderPage);
    }
    else if(order.type === "Receive Stock") {
      this.actionInCaseOfTypeReceiveStock(order)
    }
    else {


      this.api.post("workOrder/checkLicenseAndTransactionForCustomWorkOrders",order)
        .map(res=> res.json())
        .subscribe(data=>{
          if(data.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }
          if(data.status === "200"){
            this.updateWorkOrder(order);
            this.msgManager.toastMsg("Work order successfully started.");
            this.nav.push(WorkOrderViewPage,{"workOrder": order, "from":"Start"});
          }else {
            this.msgManager.toastMsg(data.message);
          }
        },err=>{
          // this.presentToast("Server error.");
        });








    }

  }

  actionInCaseOfTypeReceiveStock(order){
    if(order.type !== 'Make to Stock')
    this.updateWorkOrder(order);
    if(order.receiveType === "Return"){
      this.api.get("shipmentNotice/getShipmentNoticeById/" + order.jobId).map(res => res.json())
        .subscribe(data => {
          if(data.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }
          if(data.status === "200"){
            // alert(data.data.referenceNo)

            WORKORDER.returnStockJobReference = data.data.referenceNo;
            this.nav.setRoot(ReceiveReturnPage);
          }

        });
    }
    else {
      this.api.get("shipmentNotice/getShipmentNoticeById/" + order.jobId).map(res => res.json())
        .subscribe(data => {
          if(data.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }
          if(data.status === "200"){
            // alert(data.data.referenceNo)

            WORKORDER.jobReference = data.data.referenceNo;
            console.log("SKKUDD " + order.skusJson)
            this.nav.setRoot(StockcartPage, {calledFrom : "workOrder", skusJson: order.skusJson});
          }

        });
    }
  }

  updateWorkOrder(order){

    order.started = 1;

    this.api.post("workOrder/updateWorkOrder",order)
      .map(res=> res.json())
      .subscribe(data=>{
        if(data.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

          this.nav.setRoot(LoginPage);
        }
        if(data.status == 200){
          order.startedBy = loginUserInfo.id
        }
      },err=>{
        // this.presentToast("Server error.");
      });
  }



  getOrdersLazy(itemCount, searchOrderNumber, orderType, sortingType){
    this.gVLogger.log("get products lazy function method : " + itemCount);

    return new Promise(resolve=>{
    var ordersListCount = itemCount;

    let searchString = "";

    if(searchOrderNumber.trim() !== ""){
      searchString = searchOrderNumber;
    }

    let headers = new Headers({
        'Content-Type': 'application/json'
      });
      let options = new RequestOptions({
        headers: headers
      });

      var url = "workOrder/getWorkOrders";
      // if(Constants.isWebstore){
      //  url = "order/loadByCustomer";
      // }

      let body = {
        "offset" : ordersListCount,
        "parentInventoryLocationId": loginUserInfo.assignedWarehouseId,
        "searchQuery": searchString,
        "statusCode": this.selectedWorkOrdersStatus,
        "supplierUuid": "",
        "assignedTo" : this.selectedWorkOrdersType
      }


    this.api.post(url,body)
    .map(res=> res.json())
    .subscribe(data=>{
      if(data.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());
        this.nav.setRoot(LoginPage);
      }else if(data.status == 200){
        var temp = this.orders;


        for(let order of data.data.workOrdersList){
          this.gVLogger.log("Recived : "+order.updatedAt);
          temp.push(order);
        }

        this.orders = this.arrayUnique(temp);
        if(data.data.workOrdersList == []){
          this.allDataLoaded = true;
        }
        resolve(true);
      }
    });

    });
  }


  doInfinite(infiniteScroll){
    var arrayLength = this.orders.length;
      this.getOrdersLazy(arrayLength, this.enteredOrderNumber, this.selectedWorkOrdersType, this.selectedSortingType).then(()=>{
        infiniteScroll.complete();
      });


  }

arrayUnique(array) {
    var a = array.concat();
    for(var i=0; i<a.length; ++i) {
        for(var j=i+1; j<a.length; ++j) {
            if(a[i] === a[j])
                a.splice(j--, 1);
        }
    }

    return a;
}


decimalLengthFixed(num,max){
  if(num !== undefined)
    return Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
  }



  gotoItemsPage(){
  this.nav.setRoot(ItemsPage);
}

logOut(){
   this.nav.setRoot(LoginPage);
}

goToCart(){
  this.nav.push(CartPage);

}

goToSearch(){
  this.nav.push(SearchPage);
}


presentToast(msg){
  var toast = this.toastCtrl.create(
    {
      message:msg,
      duration: 3000,
      position: 'bottom'
  }
    );
  toast.present();
}



checkOfflineOrders(){
  this.apiOffline.getAllOrders().then((res)=>{
    if(res.rows.length>0)
      {
          this.offlineOrdersAvailable = true;
      }else{
          this.offlineOrdersAvailable = false;
      }
  });
}


syncOrders(){
   this.apiOffline.syncOrdersToServer();
  }

  getShowAds(){

    if(this.cartManager.getAdpCustomerInfo().showAds == 1){
      this.getAdByRoleId();
    }
  }

  getAdByRoleId(){
    this.api.get("/adByRoleId/"+this.cartManager.getSalesPerson().roleId)
    .map(res=>res.json())
    .subscribe(result=>{
      if(result.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }
      this.ad = result.data;
      if(this.ad.adText.trim() !== "" ){
        this.showAds = 1;
      }
    });

  }


  async end(order){
    order = await this.getWorkOrderById(order.id)
    if(order.type === "Make to Stock"){
      this.actionInCaseOfTypeReceiveStock(order)
    }else {
      loggedInUser.selectedWorkOrdersType = this.selectedWorkOrdersType
      loggedInUser.selectedWorkOrdersStatus = this.selectedWorkOrdersStatus
      order.doneBy = 1;
      order.createdAt = "";
      order.assignedAt = "";
      order.startedAt = "";
      if(order.startedBy > 0){
        order.started = 0;
        order.finished = 1
        this.api.post("workOrder/updateWorkOrder",order)
          .map(res=> res.json())
          .subscribe(data=>{
            if(data.status == "401"){ // check for session out
              this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

              this.nav.setRoot(LoginPage);
            }
            if(data.status == 200){

              order.doneBy = loginUserInfo.id
              this.msgManager.toastMsg("Work order successfully ended.");
              // return true;
            }else {
              order.done = 0
            }
          },err=>{
            order.done = 0
            // this.presentToast("Server error.");
          });
      }else {
        order.doneBy = 0;
        this.api.toastMSG("You have to start task first!")
      }

    }

    }

    getEndCaption(workOrder){
      if(workOrder.type === "Make to Stock")
        return "Receive"
      else
        return "End"
    }

  getStartCaption(workOrder){
    if(workOrder.type === "Make to Stock")
      return "Consume"
    else
      return "Start"
  }

  getWarehouse() {


    this.api.get("locations/getParentInventoryLocationById?id=" + this.loggedInUserWarehouseId)
      .map(res => res.json())
      .subscribe(data => {
        if(data.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

          this.nav.setRoot(LoginPage);
        }
        if (data.status === "200") {
          this.warehouseType = data.data.type
        } else {
          this.warehouseType = "Warehouse"
        }
      });
    // }
  }

  getStartButtonDisableStatus(workOrder, warehouseType){
    if(warehouseType !== 'A3PL' && workOrder.type === 'Make to Stock' && workOrder.doneBy <= 0){
      return false
    }
    else if(workOrder.startedBy > 0 || warehouseType === 'A3PL' || workOrder.status === 'Canceled'){
      return true
    }else return false
  }
}



// WEBPACK FOOTER //
// ./src/pages/work-orders/work-orders.ts